import { ComponentType } from 'react';

import { Element, Processor } from '@/features/html2react/types';

import PageTitle from '../components/page-title';

interface PageTitleProcessorElement extends Element {
  props: Element['props'] & {
    includeCreationDate: boolean;
    includeReadingTime: boolean;
    'data-erom-page-title-include-creation-date'?: string;
    'data-erom-page-title-include-reading-time'?: string;
  };
}

const pageTitle: Processor<PageTitleProcessorElement> = {
  priority: 10,
  name: 'pageTitle',
  test: ({ node }) => !!node.props?.className?.includes('wp-block-erom-page-title'),
  processor: ({ node }) => {
    node.props.includeCreationDate =
      !!node.props['data-erom-page-title-include-creation-date'] &&
      node.props['data-erom-page-title-include-creation-date'] === 'true';
    node.props.includeReadingTime =
      !!node.props['data-erom-page-title-include-reading-time'] &&
      node.props['data-erom-page-title-include-reading-time'] === 'true';

    node.component = PageTitle as ComponentType;

    return node;
  }
};

export default pageTitle;
